module.exports = __webpack_public_path__ + "img/item-info-icon9_r.eeded09f.svg";